import React, { useState, useEffect } from 'react';
import DIContainer from '../../../../config/di.container';
import DITYPES from '../../../../config/di.types';
import UtilService from '../../../../services/UtilService';
import '../WellnessIndustry/WellnessIndustry.scss'

const PUBLIC_URL = process.env.PUBLIC_URL;

const utilService = DIContainer.get<UtilService>(DITYPES.UtilService);
function BuildSection() {

    const [isMobileViewOne, setIsMobileView] = useState(utilService.checkIsMobileView);


    useEffect(()=>{
        window.addEventListener("resize", handleResize);
    },[])

    const handleResize = () => {
        setIsMobileView(utilService.checkIsMobileView());
      }

    return (
        <div className="pb">
            <div id="ExploreSection" className="sectionheader">
                <div className="sectionheader">
                    <h2 className="heading">Build on the leading technology platform for the wellness industry</h2>
                </div>
            </div>
            <div>
                <div className="section wellness-industry-section">
                    <div className="wrap w-i-wrap">
                        <div className="feature4-wrapper">
                            <div className="_6-col text-align-center">
                                <img alt="Boost your revenue" className="illustration1 left illustration1-img"></img>
                            </div>
                            <div className="_6-col _6-col-last">
                                <div className="feature4-text-wrap feature4-text-wrap-right">
                                    <h3 className="header-text">Exceed your revenue goals</h3>
                                    <p className="text-18 page-section">
                                        Mindbody is the go-to platform for revenue growth in wellness technology,
                                        offering you a wealth of opportunities to serve businesses and consumers alike.
                                </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section wellness-industry-section sec-two">
                    <div className="wrap w-i-wrap">
                        <div className="feature4-wrapper">
                            {isMobileViewOne && <div className="_6-col">
                                <img alt="expect more" className="illustration2 left illustration2-img"></img>
                            </div>}
                            <div className="_6-col _6-col-text">
                                <div className="feature4-text-wrap">
                                    <h3 className="header-text">Expect more from a partner</h3>
                                    <p className="text-18 page-section">
                                        At Mindbody, we go the extra mile to help your solutions succeed,
                                        with our Partner Store, hosted events, dedicated partner team
                                        and more.
                                </p>
                                </div>
                            </div>
                            {!isMobileViewOne && <div className="_6-col illustration2-div">
                                <img alt="expect more" className="illustration2 left illustration2-img"></img>
                            </div>}
                        </div>
                    </div>
                </div>
                <div className="section wellness-industry-section margin-bottom">
                    <div className="wrap w-i-wrap">
                        <div className="feature4-wrapper">
                            <div className="_6-col text-align-center">
                                <img alt="startinminutes" className="illustration3 left illustration3-img"></img>
                            </div>
                            <div className="_6-col _6-col-last">
                                <div className="feature4-text-wrap feature4-text-wrap-right">
                                    <h3 className="header-text">Start in minutes, launch in weeks</h3>
                                    <p className="text-18 page-section">
                                        You’ll have free access to our sandbox and endpoints tailored to your needs.
                                        And it doesn’t stop there – we offer developer-focused guidance at every step, 
                                        you can start easily and launch quickly.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BuildSection;
